import { Routes, Route, Navigate } from 'react-router-dom';
import Home from '../pages/Home';
import Reports from '../components/Report/Reports';
import AllReport from '../pages/AllReport';
// import SchoolReport from '../components/Report/SchoolReport';
import TeacherReport2008 from '../components/Report/TeacherReport2008';
import TeacherReport2007 from '../components/Report/TeacherReport2007';
import Infrastructure3013 from '../components/Report/InfrastructureReport3013';
import ScreenReader from '../pages/ScreenReader';
import HelpLineNumber from "../pages/HelpLineNumber";
import Infrastructure1003 from '../components/Report/InfrastructureReport1003';
import Infrastructure1005 from '../components/Report/InfrastructureReport1005';
import Infrastructure1004 from '../components/Report/InfrastructureReport1004';
import EnrolmentReport4000 from '../components/Report/EnrolmentReport4000';
import EnrolmentReport4002 from '../components/Report/EnrolmentReport/EnrolmentReport4002';
import EnrolmentReport4004 from '../components/Report/EnrolmentReport/EnrolmentReport4004';
import EnrolmentReport4006 from '../components/Report/EnrolmentReport/EnrolmentReport4006';
import EnrolmentReport4008 from '../components/Report/EnrolmentReport/EnrolmentReport4008';
import EnrolmentReport4009 from '../components/Report/EnrolmentReport/EnrolmentReport4009';
import EnrolmentReport4010 from '../components/Report/EnrolmentReport/EnrolmentReport4010';
import EnrolmentReport4011 from '../components/Report/EnrolmentReport/EnrolmentReport4011';
import EnrolmentReport4014 from '../components/Report/EnrolmentReport/EnrolmentReport4014';
import EnrolmentReport4032 from '../components/Report/EnrolmentReport/EnrolmentReport4032';
import TeacherReport2002 from '../components/Report/TeacherReport/TeacherReport2002';
import TeacherReport2009 from '../components/Report/TeacherReport/TeacherReport2009';
import TeacherReport2010 from '../components/Report/TeacherReport/TeacherReport2010';
import TeacherReport2011 from '../components/Report/TeacherReport/TeacherReport2011';
import InfrastructureReport1006 from '../components/Report/SchoolReports/SchoolReport1006';
import InfrastructureReport1007 from '../components/Report/SchoolReports/SchoolReport1007';
import InfrastructureReport1008 from '../components/Report/SchoolReports/SchoolReport1008';
import InfrastructureReport1009 from '../components/Report/SchoolReports/SchoolReport1009';
import InfrastructureReport1010 from '../components/Report/SchoolReports/SchoolReport1010';
import InfrastructureReport1011 from '../components/Report/SchoolReports/SchoolReport1011';
import TeacherReport2001 from '../components/Report/TeacherReport/TeacherReport2001';
import TeacherReport2005 from '../components/Report/TeacherReport/TeacherReport2005';
import TeacherReport2006 from '../components/Report/TeacherReport/TeacherReport2006';
import TeacherReport2004 from '../components/Report/TeacherReport/TeacherReport2004';
import TeacherReport2003 from '../components/Report/TeacherReport/TeacherReport2003';
import InfrastructureReport1013 from '../components/Report/SchoolReports/SchoolReport1013';
import InfrastructureReport1014 from '../components/Report/SchoolReports/SchoolReport1014';
import EnrolmentReport4007 from '../components/Report/EnrolmentReport/EnrolmentReport4007';
import InfrastructureReport from '../components/Report/InfrastructureReport';


export const routes = (
   
    <Routes >
        <Route exact path="/" element={<Home />} />
        <Route exact path="/reports" element={<Reports />} />
        <Route exact path="/school-reports" element={<AllReport />} />
        {/* <Route exact path="/school-reports" element={<SchoolReport />} /> */}
        <Route exact path="/school-reports-1005" element={<Infrastructure1005/>} />
        <Route exact path="/school-reports-1004" element={<Infrastructure1004/>} />
        <Route exact path="/school-reports-1003" element={<Infrastructure1003/>} />
        <Route exact path="/school-reports-1006" element={<InfrastructureReport1006/>} />
        <Route exact path="/school-reports-1007" element={<InfrastructureReport1007/>} />
        <Route exact path="/school-reports-1008" element={<InfrastructureReport1008/>} />
        <Route exact path="/school-reports-1009" element={<InfrastructureReport1009/>} />
        <Route exact path="/school-reports-1010" element={<InfrastructureReport1010/>} />
        <Route exact path="/school-reports-1011" element={<InfrastructureReport1011/>} />
        <Route exact path="/school-reports-1013" element={<InfrastructureReport1013/>} />
        <Route exact path="/school-reports-1014" element={<InfrastructureReport1014/>} />
        <Route exact path="/student-reports-4000" element={<EnrolmentReport4000/>} />
        <Route exact path="/student-reports-4002" element={<EnrolmentReport4002/>} />
        <Route exact path="/student-reports-4004" element={<EnrolmentReport4004/>} />
        <Route exact path="/student-reports-4006" element={<EnrolmentReport4006/>} />
        <Route exact path="/student-reports-4007" element={<EnrolmentReport4007/>} />
        <Route exact path="/student-reports-4008" element={<EnrolmentReport4008/>} />
        <Route exact path="/student-reports-4009" element={<EnrolmentReport4009/>} />
        <Route exact path="/student-reports-4010" element={<EnrolmentReport4010/>} />
        <Route exact path="/student-reports-4011" element={<EnrolmentReport4011/>} />
        <Route exact path="/student-reports-4014" element={<EnrolmentReport4014 />} />
        <Route exact path="/student-reports-4032" element={<EnrolmentReport4032/>} />
        <Route exact path="/teacher-reports-2008" element={<TeacherReport2008 />} />
        <Route exact path="/teacher-reports-2001" element={<TeacherReport2001 />} />
        <Route exact path="/teacher-reports-2002" element={<TeacherReport2002 />} />
        <Route exact path="/teacher-reports-2003" element={<TeacherReport2003 />} />
        <Route exact path="/teacher-reports-2004" element={<TeacherReport2004 />} />
        <Route exact path="/teacher-reports-2005" element={<TeacherReport2005 />} />
        <Route exact path="/teacher-reports-2006" element={<TeacherReport2006 />} />
        <Route exact path="/teacher-reports-2009" element={<TeacherReport2009 />} />
        <Route exact path="/teacher-reports-2010" element={<TeacherReport2010 />} />
        <Route exact path="/teacher-reports-2011" element={<TeacherReport2011 />} />
        <Route exact path="/teacher-reports-2007" element={<TeacherReport2007 />} />
        <Route exact path="/infrastructure-reports3013" element={<Infrastructure3013 />} />
        {/* <Route exact path="/infrastructure-reports3016" element={<InfrastructureReport />} /> */}
        {/* 3016: InfrastructureReport */}
        <Route exact path="/screen-reader-access" element={<ScreenReader />} />
        <Route exact path="/help-line-numbers" element={<HelpLineNumber />} />
        <Route path="/*" element={<Navigate to="/" />} />
    </Routes>
)  